import OfferService from "./OfferService";

export default OfferService;
